import _ from "lodash";
import React from "react";
import { PROJECT_TEMPLATE_FIELD_OBJECTS } from "ProcessJournal/modules/Module";
import { PROJECT_GROUP_TYPE_PERSONAL } from "Projects/Constants/stringConstants";
import Levels from "MultiLevelNodeEditor/routes/Levels/components";
import { useI18n } from "Hooks";
import { ELEMENT_TYPE_MYP_ATL } from "Constants/stringConstants";
import { connect } from "react-redux";

const getPlannerElementSetSubType = _.memoize(
  params => {
    const { projectGroupType } = params;
    return projectGroupType === PROJECT_GROUP_TYPE_PERSONAL
      ? "PERSONAL_OBJECTIVES"
      : "COMMUNITY_OBJECTIVES";
  },
  params => JSON.stringify(params)
);

const LevelsWrapper = React.memo(props => {
  const {
    screenPanelProps,
    plannerElementSets,
    projectGroupType,
    fieldData,
    elementObj,
    onSubmitClick,
    yearGroupGradeId,
    isDsComponent = false,
    dsVersion,
  } = props;
  const { onCloseClick, currentElementTag } = screenPanelProps;
  const { t } = useI18n(["common"]);

  const fieldObj = PROJECT_TEMPLATE_FIELD_OBJECTS[currentElementTag];

  const {
    plannerElementConfig: { type: elementType, subType },
    fieldTypeConfig: { rootNodeDepth: startDepth },
  } = _.get(fieldObj, "config", {});

  let elementSubType = null;

  if (subType) {
    elementSubType = getPlannerElementSetSubType({ projectGroupType });
  }

  const plannerElementSet = plannerElementSets[elementType];

  const filters = {
    startDepth,
    ...(!_.isNil(elementSubType) && { subTypes: [elementSubType] }),
    ...(_.isEqual(elementType, ELEMENT_TYPE_MYP_ATL) && {
      associatedParents: [
        {
          ids: yearGroupGradeId ? [yearGroupGradeId] : [],
          type: "GRADE",
        },
      ],
    }),
  };

  return (
    <Levels
      mode={"view"}
      isTagging={true}
      nodeType={elementType}
      label={t(elementObj.tagLabel)}
      onBackClick={onCloseClick}
      plannerElementSetConfig={{
        id: plannerElementSet.id,
        filters,
      }}
      onSubmitClick={onSubmitClick}
      nodeParentType={"PLANNER_ELEMENT"}
      value={_.get(fieldData, "value", [])}
      shouldSaveOnUpdate={false}
      isDsComponent={isDsComponent}
      dsVersion={dsVersion}
    />
  );
});

LevelsWrapper.displayName = "LevelsWrapper";

const mapStateToProps = state => {
  const yearGroupGradeId = _.get(
    state,
    "project.yearGroupDetails.grade.id",
    null
  );
  return { yearGroupGradeId };
};

export default connect(mapStateToProps)(LevelsWrapper);
